/** Session storage keys */

export const RECENTLY_WATCHED = 'recently-watched'
export const FAVOURITES = 'favourites'
export const RECENT_SEARCHES = 'recent-searches'
export const STATE_UUID = 'state-uuid'
export const LOGIN_WINDOW = 'login-window'
export const LANDING_PAGE_RENDERED = 'is-landing-page-rendered'
